/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {

    // All pages
    'common': {
      init: function() {},
      finalize: function() {
        objectFitImages();

        //Smooth scrolling JS
        (function() {
          $(function() {
            $('a[href*="#"]:not([href="#"]):not([data-parent="#accordion"])').click(function() {
              if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                  $('html, body').animate({
                    scrollTop: target.offset().top
                  }, 500);
                  return false;
                }
              }
            });
          });
        })();
        (function() {
          var didScroll;
          var lastScrollTop = 0;
          var delta = 5;
          var navbarHeight = $('.banner>.container-fluid').outerHeight();

          $(window).scroll(function(event) {
            didScroll = true;
          });
          function hasScrolled() {
            var st = $(this).scrollTop();

            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta){
              return;

            }

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight) {
              // Scroll Down
              $('header').removeClass('nav-down').css('top',-navbarHeight);
            } else {
              // Scroll Up
              if (st + $(window).height() < $(document).height()) {
                $('header').addClass('nav-down').css('top','0');
              }
            }

            lastScrollTop = st;
          }
          setInterval(function() {
            if (didScroll) {
              hasScrolled();
              didScroll = false;
            }
          }, 250);

        })();


        //Page navigation
        (function() {
          function sticky_relocate() {
            if (window.location.pathname !== '/') {
              var window_top = $(window).scrollTop();
              var footer_top = $("footer").offset().top;
              var div_top = $('#checkdiv').offset().top;
              var div_height = $("#navbar-example").height();
              var main_section = $(".main-section").height();
              var header_h = $("header").height();

              var padding = 20; // tweak here or get from margins etc

              if (window_top + div_height > footer_top - padding) {
                $('#navbar-example').css({
                  top: (window_top + div_height - footer_top + padding) * -1
                });
              } else if (window_top > div_top) {
                $('#navbar-example').removeClass('stickydivTop');
                $('#navbar-example').addClass('stickydiv');
                $('#navbar-example').css({
                  top: 140
                });
              } else {
                $('#navbar-example').removeClass('stickydiv');
                $('#navbar-example').addClass('stickydivTop');
                $('#navbar-example').css({
                  top: (main_section + header_h + 440)
                });
              }
            }
          }


          $(function() {
            $(window).scroll(sticky_relocate);
            sticky_relocate();
          });

          /////////
          var sections = $('section');
          var nav = $('.page-nav');
          var nav_height = nav.outerHeight();

          $(window).on('scroll', function() {
            var cur_pos = $(this).scrollTop();

            sections.each(function() {
              var top = $(this).offset().top - nav_height;
              var bottom = top + $(this).outerHeight();
              if ($('.page-nav .current_page_item').length) {
                  if (cur_pos >= top && cur_pos <= bottom) {
                    nav.find('.current_page_item ul li a').removeClass('active');
                    nav.find('.current_page_item ul li.active').removeClass('active');
                    sections.removeClass('active');

                    $(this).addClass('active');
                    nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
                    nav.find('.current_page_item a.active').parent().addClass('active');

                  }
              } else {
                  if (cur_pos >= top && cur_pos <= bottom) {
                    nav.find('.current_page_parent ul li a').removeClass('active');
                    nav.find('.current_page_parent ul li.active').removeClass('active');
                    sections.removeClass('active');

                    $(this).addClass('active');
                    nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
                    nav.find('.current_page_parent a.active').parent().addClass('active');

                  }
              }


            });
          });

          nav.find('a').on('click', function() {
            // var $el = $(this);
            // var id = $el.attr('href');
            //
            //
            // $('html, body').animate({
            //   scrollTop: $(id).offset().top - nav_height
            // }, 500);
            //
            // $('html, body').animate({
            //   scrollTop: $(id).offset().top - nav_height
            // }, 500);
            //
            // return false;
          });
        })();


        // See More Button function
        (function() {
          $(document).on('click', '.js-see-more', function(e) {
            e.preventDefault();
            autoHeight = $(this).closest('div').find('.paregraph--collapsed').get(0).scrollHeight;
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
              $(this).text('Read More');
              if ($(window).width() < 992) {
                $(this).closest('div').find('.paregraph--collapsed').css('height', '68');
              } else if ($(window).width() >= 992 && $(window).width() <= 1200) {
                $(this).closest('div').find('.paregraph--collapsed').css('height', '136');
              } else {
                $(this).closest('div').find('.paregraph--collapsed').css('height', '116');
              }
            } else {
              $(this).addClass('active');
              $(this).text('Read Less');
              $(this).closest('div').find('.paregraph--collapsed').css('height', autoHeight);
            }
          });
        })();

        // JavaScript to be fired on all pages
        (function() {
            // Bootstap selet for dropdown menu
            $('select').selectpicker({
                size: false,
                width: '100%',
                showContent: false
              });


          $('.therapie-offers-carousel').slick({
            dots: false,
            arrows: false,
            autoplay: false,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            slidesPerRow: 1,
            rows: 2,
            responsive: [{
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesPerRow: 1,
                  rows: 2
                }
              },
              {
                breakpoint: 543,
                settings: {
                  slidesToShow: 2,
                  slidesPerRow: 1,
                  rows: 1
                }
              }
            ]

          });

        })();

        //Therapie offers items - equal height
        (function() {

          var heights = $(".therapie-offers-carousel .item").map(function() {
              return $(this).height();
            }).get(),
            maxHeight = Math.max.apply(null, heights);
          $(".therapie-offers-carousel .item").height(maxHeight);

        })();

        $('#slick_prev').click(function() {
          $('.therapie-offers-carousel').slick('slickPrev');
        });

        $('#slick_next').click(function() {
          $('.therapie-offers-carousel').slick('slickNext');
        });

        //Genrate Page navigation
        (function() {

          var pageNav = $('.page-nav');
          var pageSections = $('section');

          var sectionsArray = [];
          for (var i = 0; i < pageSections.length; i++) {
            if ($(pageSections[i]).attr('id')) {
              var href = $(pageSections[i]).attr('id');
              var title = $(pageSections[i]).attr('data-title');
              if (href !== undefined && title !== undefined) {
                sectionsArray.push('<ul><li><a href="#' + href + '">' + title + '</a></li></ul>');
              }
            }
          }
          $(pageNav).find('a').each(function() {
              if ($('.page-nav .current-menu-item').length) {
                //   console.log('asdha');
                  if ($(this).html().toLowerCase().replace('/ ', '').replace(/-/g, ' ').replace('&amp; ', '') === $(pageNav).find('.current-menu-item > a').html().toLowerCase().replace(/-/g, ' ')) {
                    for (var i = 0; i < sectionsArray.length; i++) {
                      $(this).closest('li').append(sectionsArray[i]);
                    //   console.log(sectionsArray);
                    }
                  }
              } else {
                  if ($(this).html().toLowerCase().replace('/ ', '').replace(/-/g, ' ').replace('&amp; ', '') === $(pageNav).find('.current-menu-parent > a').html().toLowerCase().replace(/-/g, ' ')) {
                    for (var j = 0; j < sectionsArray.length; j++) {
                      $(this).text('International patients');
                      $(this).attr('href', '/international-patients');
                      $(this).closest('li').append(sectionsArray[j]);
                    }
                  }
              }

          });
        })();

        // JavaScript to be fired on all pages
        (function() {

          // Footer carousel
          $('.footer-carousel').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            speed: 300,
            slidesToShow: 7,
            slidesToScroll: 1,
            rows: 1,
            responsive: [{
                breakpoint: 1920,
                settings: {
                  slidesToShow: 5
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 4
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  centerMode: true
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  centerMode: true
                }
              }
            ]
          });

          //Awards items - equal height
          var biggestHeight = 0;
          $('footer .footer-carousel .slick-track').each(function() {
            if ($(".item").height() > biggestHeight) {
              biggestHeight = $(this).height();
            }
          });
          $('footer .footer-carousel .slick-track .item').height(biggestHeight);
        })();


        // Social sidebar
        if ($(window).width() < 1200) {
          $(".menu-btn").on("click", function() {
            $(".social-sidebar").toggle(this.checked);
          });
        }

        $(".modal").on('hidden.bs.modal', function (e) {
            $(".modal iframe").attr("src", $(".modal iframe").attr("src"));
        });

        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        /**
         *  [--js/functions.js-- ]
         * Ajax search
         */

        /**
         * [--js/functions.js--]
         * Ajax search
         */

        $('.search-field').keyup(function(event) {

          // prevent browser autocomplete
          $(this).attr('autocomplete', 'off');
          // get search term
          var searchTerm = $(this).val();

          // send request when the lenght is gt 2 letters

          $.ajax({
            // url: BASE + '/wp/wp-admin/admin-ajax.php', on local
            url: BASE + '/wp-admin/admin-ajax.php',

            type: "POST",
            data: {

              'action': 'berlin_ajax_search',
              'term': searchTerm
            },
            success: function(result) {
              $('.berlin_ajax_search').fadeIn().html(result);
            }
          });
        });
        // if ($(window).width() > 1200) {
        //   var setCookie = function(name, value) {
        //     var date = new Date(),
        //       expires = 'expires=';
        //     date.setTime(date.getTime() + 31536000000);
        //     expires += date.toGMTString();
        //     document.cookie = name + '=' + value + '; ' + expires + '; path=/';
        //   };
        //   var getCookie = function(name) {
        //     var allCookies = document.cookie.split(';'),
        //       cookieCounter = 0,
        //       currentCookie = '';
        //     for (cookieCounter = 0; cookieCounter < allCookies.length; cookieCounter++) {
        //       currentCookie = allCookies[cookieCounter];
        //       while (currentCookie.charAt(0) === ' ') {
        //         currentCookie = currentCookie.substring(1, currentCookie.length);
        //       }
        //       if (currentCookie.indexOf(name + '=') === 0) {
        //         return currentCookie.substring(name.length + 1, currentCookie.length);
        //       }
        //     }
        //     return false;
        //   };
        //
        //   var hideMessage = function() {
        //     $('#specialOffer').modal('hide');
        //     setCookie('cookie', 'true');
        //   };
        //   if (getCookie('cookie')) {
        //     $('#specialOffer').modal('hide');
        //   } else {
        //     $('#specialOffer').modal('show');
        //   }
        //   $('#specialOffer').on('hidden.bs.modal', function (e) {
        //     hideMessage();
        //   });
        // }


        // JavaScript to be fired on the home page
        $(document).ready(function() {

          var vid = document.getElementById('showreel');
          var videoWrapper = $(vid).parents('.video');

          function playVid() {
            vid.play();
          }

          function pauseVid() {
            vid.pause();
          }

          $('.js-anchor--play-video').on('click', function(e) {
            e.preventDefault();
            if (videoWrapper.hasClass('is-fullscreen')) {
              videoWrapper.removeClass('is-fullscreen');
              vid.removeAttribute('controls', 'controls');
              vid.play();
              vid.muted = true;
            } else {
              videoWrapper.addClass('is-fullscreen');
              vid.setAttribute('controls', 'controls');
              vid.muted = false;
              vid.pause();
              vid.currentTime = 0;
              vid.play();
            }
          });
          $('.js-anchor--hide-video').on('click', function(e) {
            e.preventDefault();
            if (videoWrapper.hasClass('is-fullscreen')) {
              videoWrapper.removeClass('is-fullscreen');
              vid.removeAttribute('controls', 'controls');
              vid.currentTime = 0;
              vid.play();
              vid.muted = true;
            } else {
              videoWrapper.addClass('is-fullscreen');
              vid.setAttribute('controls', 'controls');
              vid.muted = false;
              vid.play();
            }
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        svg4everybody();
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'dental_lexicon': {
      init: function() {
        function callLexiconContent(index) {
          // prevent browser autocomplete
          // get search term
          var searchTerm = index;

          // send request when the lenght is gt 2 letters©

          $.ajax({
            // url: BASE + '/wp/wp-admin/admin-ajax.php',
            url: BASE + '/wp-admin/admin-ajax.php',
            type: "POST",
            data: {

              'action': 'berlin_ajax_lexicon_index',
              'term': searchTerm
            },
            success: function(result) {
              $('#lexicon_ajax_contents').fadeIn().html(result);
               $('html,body').animate({
                   scrollTop: $("#lexicon_ajax_contents").offset().top - 100
               }, 500);
            }
          });
        }
        (function() {

          var pageNavMobile = $('.page-nav-mobile');
          var pageNav = $('.page-nav');

          var pageSections = $('a');

          var sectionsArray = [];
          for (var i = 0; i < pageSections.length; i++) {
            if ($(pageSections[i]).attr('id') && $(pageSections[i]).attr('data-title').length === 1) {
              var href = $(pageSections[i]).attr('id');
              var title = $(pageSections[i]).attr('data-title');
              if (href !== undefined && title !== undefined) {
                sectionsArray.push('<ul><li><a data-index="' + title.toLowerCase() + '" href="#' + href + '">' + title + '</a></li></ul>');
                // console.log(sectionsArray);
              }
            }
          }
          $(pageNav).find('a').each(function() {
            if ($(this).html().toLowerCase().replace('/ ', '').replace(/-/g, ' ').replace('&amp; ', '') === $(pageNav).find('.current-menu-item > a').html().toLowerCase().replace(/-/g, ' ')) {
              for (var i = 0; i < sectionsArray.length; i++) {
                $(this).closest('li').append(sectionsArray[i]);
              }
            }
          });
        })();
        $('[data-index]').click(function(event) {
          event.preventDefault();
          console.log('clicked');
          $('[data-index]').removeClass('index-active');
          $(event.target).addClass('index-active');
          var index = $(event.target).attr('data-index');
          callLexiconContent(index);
        });
      }

    },
    'contacts': {
      init: function() {
        // JavaScript to be fired on the contacts page
        function initMap() {
          var latlng = {
            lat: 52.508712,
            lng: 13.378564
          };
          // Create Map
          var map = new google.maps.Map(document.getElementById('map'), {
            center: latlng,
            zoom: 15
          });
          // Create Info Window
          var infowindow = new google.maps.InfoWindow({
            content: '<strong>Leipziger Pl. 3</strong><br />' +
              '10117 Berlin<br />' +
              'Germany'
          });
          // Create Map Marker
          var marker = new google.maps.Marker({
            position: latlng,
            map: map
          });
          // Open Info Window on Marker click
          marker.addListener('click', function() {
            infowindow.open(map, marker);
          });
        }
        initMap();
      }
    }
  };


  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };


  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
